<template>
  <div :class="['about-page', {'is-flag': $flag}]">
    <div class="top-banner" :style="{ backgroundImage: 'url(' + imgUrl + ')' }">
      <div class="banner-content">
        <h1>关于我们</h1>
        <p>创新融合，构建数字医学影像应用生态</p>
      </div>
    </div>

    <section class="profile-section">
      <div class="container profile-layout">
        <div class="profile-image" v-if="!$flag">
          <img src="../assets/imgs/pic4.png" alt="Huitu Tech Office" />
        </div>
        <div class="profile-info">
          <div class="section-header tl">
            <h2 class="section-title">公司简介</h2>
            <p class="section-subtitle">COMPANY PROFILE</p>
            <div class="title-line tl"></div>
          </div>
          <div class="profile-text">
            汇图科技（浙江）有限公司于2023年05月成立，是一家以医学影像云存储、管理为基础，提供了医学影像共享、远程会诊、双向转诊、移动阅片、远程影像诊断等为核心服务的智慧医疗服务型公司。
          </div>
          <div class="profile-text">
            我们致力于提高医疗机构信息化、移动化水平及跨院业务协作，为患者、医生、医疗机构提供专业医学数字影像服务。科学的将云计算、大数据、人工智能等技术与医学影像创新融合，打造“专业影像云+人工智能应用平台”，并以平台为基，服务医疗全场景、全流程，构建数字医学影像应用生态。公司秉持以市场需求为向导，以客户需求为己任，通过不断创新，为不同客户提供更加具有性价比的医疗产品服务。
          </div>
        </div>
      </div>
    </section>

    <section class="service-section">
      <div class="container">
        <div class="section-header tc">
          <h2 class="section-title">服务类型</h2>
          <p class="section-subtitle">SERVICE TYPES</p>
          <div class="title-line"></div>
        </div>
        
        <div class="type-grid">
          <div class="service-card" v-for="item in typeList" :key="item.id">
            <img :src="item.url" :alt="item.title" />
            <div class="card-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {
      imgUrl: this.$flag
        ? require('@/assets/imgs/banner.png')
        : require('@/assets/imgs/aboutus.png'),
      typeList: [
        {
          id: 1,
          title: '医疗影像系统',
          url: require('@/assets/imgs/icon-pro1.png'),
        },
        {
          id: 2,
          title: '企业定制服务',
          url: require('@/assets/imgs/icon-pro3.png'),
        },
        {
          id: 3,
          title: '大数据人工智能',
          url: require('@/assets/imgs/icon-pro2.png'),
        },
      ],
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/about.less";
</style>
